"use client"

import { useEffect, useRef } from "react"

import { registerBonusProgramAfterSuccessfulOrderAction } from "@/actions/bonusProgramActions"
import {
  BONUS_PROGRAM_CHECKOUT_INTENT_CONSUMED_SESSION_STORAGE_KEY,
  BONUS_PROGRAM_CHECKOUT_INTENT_SESSION_STORAGE_KEY,
} from "@/lib/storefront/account/bonus-program-checkout"

interface CheckoutBonusProgramRegistrationClientProps {
  createdOrder: unknown
}

export default function CheckoutBonusProgramRegistrationClient(props: CheckoutBonusProgramRegistrationClientProps) {
  const processedRef = useRef(false)

  useEffect(() => {
    if (processedRef.current || !props.createdOrder || typeof window === "undefined") {
      return
    }

    const intent = window.sessionStorage.getItem(BONUS_PROGRAM_CHECKOUT_INTENT_SESSION_STORAGE_KEY)
    if (intent !== "true") {
      return
    }

    processedRef.current = true
    window.sessionStorage.setItem(BONUS_PROGRAM_CHECKOUT_INTENT_CONSUMED_SESSION_STORAGE_KEY, "true")
    window.sessionStorage.removeItem(BONUS_PROGRAM_CHECKOUT_INTENT_SESSION_STORAGE_KEY)
    registerBonusProgramAfterSuccessfulOrderAction()
  }, [props.createdOrder])

  return null
}
